import { useCallback, useMemo, useRef, useState } from "react";

import { Turnstile, TurnstileInstance, TurnstileProps } from "@marsidev/react-turnstile";

export const useTurnstile = (widgetOptions: Partial<TurnstileProps["options"]> = {}) => {
    const { turnstileSiteKey } = window.APP_SETTINGS;

    const [token, setToken] = useState<string | null>(null);
    const widgetRef = useRef<TurnstileInstance>();

    const onSuccess = useCallback((t: string) => {
        setToken(t);
    }, []);

    const reset = useCallback(() => {
        setToken(null);
        widgetRef?.current?.reset();
    }, []);

    const onExpire = useCallback(() => {
        reset();
    }, [reset]);

    const widget = useMemo(
        () =>
            turnstileSiteKey ? (
                <Turnstile
                    siteKey={turnstileSiteKey}
                    onSuccess={onSuccess}
                    onExpire={onExpire}
                    options={{ theme: "light", size: "flexible", ...widgetOptions }}
                    ref={widgetRef}
                />
            ) : null,
        [onExpire, onSuccess, turnstileSiteKey, widgetOptions]
    );

    return useMemo(
        () =>
            turnstileSiteKey
                ? { widget, token, isEnabled: true, reset }
                : { widget: null, token: null, isEnabled: false, reset },
        [reset, token, turnstileSiteKey, widget]
    );
};
